function lookupTranslation(path) {
  const root = typeof window === "undefined" ? undefined : window.SchoolBridge?.translations?.react;
  if (!root) {
    return undefined;
  }

  return path.split(".").reduce((current, segment) => current?.[segment], root);
}

function interpolate(template, vars = {}) {
  return Object.entries(vars).reduce((result, [key, value]) => {
    return result.replaceAll(`%{${key}}`, String(value));
  }, template);
}

export default function t(path, fallbackOrVars = "", maybeVars = {}) {
  const fallback = typeof fallbackOrVars === "string" ? fallbackOrVars : "";
  const vars = typeof fallbackOrVars === "string" ? maybeVars : fallbackOrVars || {};
  const translated = lookupTranslation(path);
  const resolved = typeof translated === "string" ? translated : fallback;
  return interpolate(resolved, vars);
}
